/**
 * author: Ananthapadmanabhan
 */
import React, { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import { OverlayTrigger } from "react-bootstrap";
import "./RiskScoreAdminMain.scss";
import { withTranslation } from "react-i18next";
import moment from "moment";
import { Collapse } from "react-bootstrap";
import {
  BiChevronDown,
  BiPlus,
  BiGitMerge,
  BiBorderAll,
  BiPencil,
} from "react-icons/bi";
import "react-bootstrap-typeahead/css/Typeahead.css";
import RiskConfigService from "../../../../core/service/RiskConfigService";
import RiskParameter from "../RiskParameter/RiskParameter";
import AddRiskParameter from "../AddRiskParameter/AddRiskParameter";
import { SCORINGOPTIONS } from "../../../../core/constants/common";
import ScoringMethod from "../ScoringMethod/ScoringMethod";
import RegulationCreate from "../RegulationCreate/RegulationCreate";
import Utils from "../../../../core/utilities/Utils";
import LinkDataSource from "../LinkDataSource/LinkDataSource";
import { RegulationContext } from "../../../../App";
const RiskScoreAdminMain = ({
  t,
  list,
  listType,
  handleChildToggle,
  selectedRegulation,
  parent,
  addRiskParent,
  handleRegEdit,
  configType,
}) => {
  const [riskParams, setRiskParams] = useState([]);
  const [addRiskParameter, setAddRiskParameter] = useState(false);
  const [editRiskParameterId, setEditRiskParameterId] = useState("");
  const [regulationId, setRegulationId] = useState(
    listType === "REGULATION" ? list.id : selectedRegulation
  );
  // const [shown, setShown] = useState(
  //   listType === "REGULATION"
  //     ? selectedRegulation === '' 
  //       ? {}
  //       : { [selectedRegulation]: true }
  //     : { [list.id]: true }
  // );
  // const [shown, setShown] = useState(
  //   listType === "REGULATION"
  //     ? { [selectedRegulation]: true }
  //     : { [list.id]: true }
  // );

  const [shown, setShown] = useState({});
  const [type, setType] = useState(listType);
  const [parentId, setParentId] = useState(parent);
  const [disabled, setDisabled] = useState("disabled");
  const [formulae, setFormulae] = useState(list.formulae ? list.formulae : 0);
  const [isScoring, setIsScoring] = useState(false);
  const [openRegulationSave, setOpenRegulationSave] = useState(false);
  const [editReg, setEditReg] = useState({});
  const [riskConfig, setRiskConfig] = useState([]);
  const [showDataSource, setShowDataSource] = useState(false);
  const { glbRegulations, setGlbRegulations } = useContext(RegulationContext);
  const [selParam, setSelParam] = useState("");
  const [selDsId, setSelDsId] = useState("");
  useEffect(() => {
    setShown(
      listType === "REGULATION"
        ? { [selectedRegulation]: true }
        : { [list.id]: true }
    );
    if (type === "RISK") {
      getRiskParameters();
    } else if (selectedRegulation) {
      getRegulationDetails(selectedRegulation);
    }
  }, [list?.children, configType]);
  const handleExpand = (id) => {
    const newVal = !shown[id];
    var obj = function (shown) {
      Object.keys(shown).forEach(function (key) {
        shown[key] = false;
      });
      return shown;
    };
    setShown({
      ...obj,
      [id]: newVal,
    });

    newVal === false && setDisabled("disabled");
    newVal === false && setAddRiskParameter(false);
    if (type === "REGULATION") {
      getRegulationDetails(id);
    } else if (type === "RISK") {
      getRiskParameters();
    }
  };
  const getRiskParameters = () => {
    var data = list.children;
    data ? setRiskParams([...data]) : setRiskParams([]);
    data ? setFormulae(list.formulae) : setFormulae("0");
    data && data.length > 1 ? setDisabled("") : setDisabled("disabled");
  };
  const getRegulationDetails = (id) => {
    if (list.id === id) {
      RiskConfigService.getRegulationDetails(id, configType)
        .then((response) => {
          var data = response.data.riskParams;
          if (type === "REGULATION") {
            list.status = response.data.status;
          }
          var riskCateg = response.data.resultConfigs;
          data
            ? setRiskParams([...response.data.riskParams])
            : setRiskParams([]);
          riskCateg ? setRiskConfig(riskCateg) : setRiskConfig([]);
        })
        .catch((error) => {
        });
    }
  };
  const handleRiskDiscard = (isDiscard) => {
    setAddRiskParameter(!isDiscard);
  };
  const handleRiskEdit = (paramId) => {
    setEditRiskParameterId(paramId);
    setAddRiskParameter(true);
  };
  const handleAfterSave = (id) => {
    if (id) {
      handleChildExpand(id);
    } else {
      list.status = "DRAFT";
      type === "REGULATION" && getRegulationDetails(regulationId);
    }
  };
  const handleChildExpand = (id, dataSource = false) => {
    if (type === "REGULATION") {
      localStorage.setItem('regulationName', list.name);
      localStorage.setItem('regulationFrequency', list.frequency);
      localStorage.setItem('lastModify', list.lastModifiedDate);
    }
    var data = {
      paramId: id,
      regulationId: regulationId,
      childStatus: "Expand",
      type: "RISK",
      configType: configType,
    };
    dataSource && setShowDataSource(true);
    handleChildToggle(data);
  };
  const handleCloseChild = (id) => {
    var data = {
      paramId: id,
      regulationId: regulationId,
      childStatus: "Close",
      type: "RISK",
      parent: parentId,
      configType: configType,
    };
    handleChildToggle(data);
  };
  const changeScoring = (e) => {
    setFormulae(e.target.value);
    setIsScoring(true);
  };
  const handlePublish = (regId) => {
    RiskConfigService.publishRegulation(regId)
      .then((response) => {
        if (response.status === 200) {
          getRegulationDetails(regId);
          setGlbRegulations(response.data);
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((error) => {
        // toast.error(error.response.data.message, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
      });
  };
  const updateRegulation = (params, regId) => {
    RiskConfigService.updateRegulation(params, regId)
      .then((response) => {
        if (response.status === 200) {
          setGlbRegulations(response.data);
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          getRegulationDetails(regId);
        }
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
        // toast.error(error.message, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
      });
  };
  const handleShow = () => {
    setIsScoring(true);
  };
  const handleScoring = (val) => {
    setIsScoring(val);
  };
  const editRegulation = (regId) => {
    setOpenRegulationSave(true);
    // getRegulationDetails (regId);
    setEditReg(list);
    //console.log(editReg);
  };
  const editRegulationCallback = (val, regId) => {
    regId && getRegulationDetails(regId);
    setOpenRegulationSave(val);
  };
  const handleRiskDelete = (obj) => {
    RiskConfigService.deleteRiskParameter(regulationId, obj.id)
      .then((response) => {
        if (response.status === 204) {
          if (obj?.parent?.id) {
            handleChildExpand(obj?.parent?.id);
          } else {
            type === "REGULATION" && getRegulationDetails(regulationId);
          }
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((error) => { });
  };

  const handleDataSourceCallback = (val) => {
    setShowDataSource(false);
    if (val) {
      type === "REGULATION"
        ? getRegulationDetails(regulationId)
        : handleChildExpand(addRiskParent);
    }
  };
  const handleDatasourceLink = (action, riskId, dsId = "") => {
    if (action === "link") {
      setSelParam(riskId);
      setSelDsId(dsId);
      setShowDataSource(true);
    } else if (action === "unlink") {
      RiskConfigService.unlinkDatasource(regulationId, riskId)
        .then((response) => {
          if (response.status === 200) {
            toast.success("Success", {
              position: toast.POSITION.TOP_RIGHT,
            });
            type === "REGULATION"
              ? getRegulationDetails(regulationId)
              : handleChildExpand(riskId);
          }
        })
        .catch((error) => { });
    }
  };

  return (
    <>
      {type === "RISK" && <div className="Topics_headeView">
        <ul>
          <li>
            Risk : <b>{localStorage.getItem('regulationName')}</b>
            {type === "REGULATION" ? (
              <div className="p-1 text-end">
                <div className="row m-0  3">
                  {/* {userData.roles.includes("SUPER_ADMIN") && ( */}
                  <div className="col-lg-4 p-0 text-end">
                    <OverlayTrigger
                      placement="top"
                      overlay={Utils.renderTooltip(
                        t("EditCompliance.label")
                      )}
                    >
                      <button
                        className="btn btn-blank_outline"
                        onClick={() => editRegulation(list.id)}
                      >
                        <BiPencil />
                      </button>
                    </OverlayTrigger>
                  </div>
                  {/* )} */}
                  {list.status === "DRAFT" && (
                    <div className="btn-custom p-0 text-end">
                      <button
                        className="btn btn-primary "
                        onClick={(e) => handlePublish(list.id)}
                      >
                        {t("Publish.label")}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ) : type === "RISK" ? (
              <div className="btn-custom p-1 text-end">
                <button
                  className="btn btn-secondary"
                  onClick={() => handleCloseChild(list.id)}
                >
                  {t("Back.label")}
                </button>
              </div>
            ) : (
              ""
            )
            }
          </li>
          <li>
            {t("ReportingFrequency.label")} : <b>{t(localStorage.getItem('regulationFrequency') + ".label")}</b>
          </li>
          <li>
            {t("LastModified.label")} : <b> {moment(localStorage.getItem('lastModify')).format(
              "MMM DD, YYYY"
            )}</b>
          </li>

          {type === "RISK" && <>

            <li>
              {t("RiskParameter.label")} : <b>{list.name}</b>
            </li>
            {/* <li>
          {t("ChildParameter.label")} : <b>{list.name}</b>
          </li> */}
          </>}
        </ul>

      </div>}
      {showDataSource ? (
        <LinkDataSource
          regulation={regulationId}
          paramId={selParam}
          dsId={selDsId}
          handleDataSourceCallback={handleDataSourceCallback}
          configType={configType}
        />
      ) : (
        <div
          className={`card RSW_Add_Card ${list.status === "DRAFT" ? "bg-light-blue" : ""
            } `}
          id={list.id}
          key={list.id}
        >
          <div className="card-body p-0">
            <div className="RSW_Add_Card_row01">
              <div className="expand_RswBox 12">
                <BiChevronDown
                  onClick={(e) => handleExpand(list.id)}
                  aria-controls="example-collapse-text"
                  aria-expanded={shown[list.id]}
                ></BiChevronDown>
              </div>
              <div className="row m-0">
                {type === "REGULATION" ? (
                  <div className="col-lg-8 p-1">
                    <div className="row m-0 RSW_Add_Card_head 4">
                      <div className="col-lg-4 p-0">
                        <ul>
                          <li>
                            <h6 className="mb-0 me-2">{list.name}</h6>
                          </li>
                        </ul>
                      </div>
                      <div className="col-lg-4 p-0">
                        <ul>
                          <li>
                            {t("ReportingFrequency.label")}
                            <h6 className="mb-0 ms-2">
                              {t(list.frequency + ".label")}
                            </h6>
                          </li>
                        </ul>
                      </div>
                      <div className="col-lg-4 p-0">
                        <ul>
                          <li>
                            {t("LastModified.label")}{" "}
                            <h6 className="mb-0 ms-2">
                              {moment(list.lastModifiedDate).format(
                                "MMM DD, YYYY"
                              )}
                            </h6>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="col-lg-8 p-1">
                    <div className="row m-0 RSW_Add_Card_head">
                      <div className="col-lg-4 p-0">
                        <ul>
                          <li>
                            <h6 className="mb-0 me-2">{list.name}</h6>
                          </li>
                        </ul>
                      </div>
                      <div className="col-lg-3 p-0">
                        <button
                          type="button"
                          className="cursor border-0 bg-transparent p-0"
                          onClick={() => handleChildExpand(list.id)}
                          aria-label={t("RiskScoreAdminMain.expandChildren.label") || `Expand children for ${list.name}`}
                        >
                          <ul className="m-0 p-0 list-unstyled d-flex align-items-center">
                            <li>
                              <h6 className="mb-0 ms-2">
                                {list.children ? list.childrenCount : 0}
                              </h6>
                            </li>
                            <li>
                              <BiGitMerge />
                            </li>
                          </ul>
                        </button>
                      </div>
                      <div className="col-lg-5 p-0">
                        <ul>
                          <li>
                            <OverlayTrigger
                              placement="top"
                              overlay={Utils.renderTooltip(
                                t("ScoringFormula.label")
                              )}
                            >
                              <span>{t("ScoreingMethod.label")} </span>
                            </OverlayTrigger>
                            <h6 className="mb-0 ms-2">
                              <select
                                className="form-select"
                                name="scoring"
                                disabled={disabled}
                                defaultValue={formulae}
                                onChange={(e) => changeScoring(e)}
                              >
                                <option value="0" disabled hidden>
                                  {t("Select.label")}
                                </option>
                                {SCORINGOPTIONS.map(({ value, label }) => (
                                  <option key={value} value={value}>
                                    {label}
                                  </option>
                                ))}
                              </select>
                            </h6>
                            &nbsp;
                            <OverlayTrigger
                              placement="top"
                              overlay={Utils.renderTooltip(
                                t("ScoringFormula.label")
                              )}
                            >
                              <span>
                                <BiBorderAll onClick={handleShow} />
                              </span>
                            </OverlayTrigger>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                )}

                {type === "REGULATION" ? (
                  <div className="col-lg-4 p-1 text-end">
                    <div className="row m-0 RSW_Add_Card_head">
                      {/* {userData.roles.includes("SUPER_ADMIN") && ( */}
                      <div className="col-lg-4 p-0 text-end">
                        <OverlayTrigger
                          placement="top"
                          overlay={Utils.renderTooltip(
                            t("EditCompliance.label")
                          )}
                        >
                          <button
                            className="btn btn-blank_outline"
                            onClick={() => editRegulation(list.id)}
                          >
                            <BiPencil />
                          </button>
                        </OverlayTrigger>
                      </div>
                      {/* )} */}
                      {list.status === "DRAFT" && (
                        <div className="col-lg-8 p-0 text-end">
                          <button
                            className="btn btn-primary "
                            onClick={(e) => handlePublish(list.id)}
                          >
                            {t("Publish.label")}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                )
                  //  : type === "RISK" ? (
                  //   <div className="col-lg-4 p-1 text-end">
                  //     <button
                  //       className="btn btn-secondary"
                  //       onClick={() => handleCloseChild(list.id)}
                  //     >
                  //       {t("Close.label")}
                  //     </button>
                  //   </div>
                  // ) 
                  : (
                    ""
                  )}
                {/* {console.log(shown)} */}
                {/* {console.log(Object.keys(shown).length)}
                {Object.keys(shown).length === 0 ? "HI" :"HELLO" } */}
                <Collapse in={shown[list.id]}>
                  <div className="col-lg-12 p-1">
                    {riskConfig.length > 0 && (
                      <div className="row m-0">
                        <div className="col-lg-3 p-2">
                          {t("RiskCategories.label")}
                        </div>
                        {riskConfig?.map((categ) => (
                          <div className="col-lg-3 p-2" key={categ.id}>
                            <ul>
                              <li>
                                <span style={{ color: categ.colorCode }}>
                                  {categ.resultType}
                                </span>
                              </li>
                              <li>
                                <h6 className="mb-0">
                                  {categ.minScore}-{categ.maxScore}
                                </h6>
                              </li>
                            </ul>
                          </div>
                        ))}
                      </div>
                    )}
                    {riskParams.length > 0 ? (
                      <RiskParameter
                        riskParams={riskParams}
                        handleEdit={handleRiskEdit}
                        handleChild={handleChildExpand}
                        handleDelete={handleRiskDelete}
                        handleDatasourceLink={handleDatasourceLink}
                      />
                    ) : (
                      <div>{t("NoRulesConfigured.label")}</div>
                    )}

                    <div className="col-lg-12 p-1" id="idRiskParameter">
                      <button
                        className="btn btn-secondary"
                        onClick={() => {
                          setAddRiskParameter(true);
                          setEditRiskParameterId("");
                          setShown({
                            ...shown,
                            [list.id]: true,
                          });
                        }}
                      >
                        <BiPlus className="me-2"> </BiPlus>
                        {t("RiskParameter.label")}
                      </button>
                    </div>
                  </div>
                </Collapse>
              </div>
              {addRiskParameter && (
                <AddRiskParameter
                  regulation={regulationId}
                  handleDiscard={handleRiskDiscard}
                  editRiskId={editRiskParameterId}
                  handleSave={handleAfterSave}
                  type={type}
                  addRiskParent={addRiskParent}
                  configType={configType}
                />
              )}
            </div>
          </div>
        </div>
      )}

      {isScoring && (
        <ScoringMethod
          formulaeType={formulae}
          riskParams={riskParams}
          regulation={regulationId}
          paramId={addRiskParent}
          handleScoring={handleScoring}
          list={list}
        />
      )}

      {openRegulationSave && (
        <RegulationCreate
          handleCreateReg={editRegulationCallback}
          editReg={editReg}
          configType={configType}
        />
      )}
    </>
  );
};
RiskScoreAdminMain.propTypes = {};
export default withTranslation()(RiskScoreAdminMain);
